import { Platform } from 'react-native'
import { DefaultTheme, NavigationContainer } from '@react-navigation/native'
import * as AuthSession from 'expo-auth-session'
import * as WebBrowser from 'expo-web-browser'

import AppStack from './AppStack'
import AuthStack from './AuthStack'

import { useAuthStore } from '../stores/auth'

// styles
import { colorPalette } from '../static/styles/global'

// config
import { CLIENT_ID, REDIRECT_URI, discovery } from '../config'
import { useEffect, useState } from 'react'
import { useHomeStore } from '../stores/home'
import { usePersonalStore } from '../stores/personalInfo'
import { useInitializeStore } from '../stores/initialize'
import { useCommunicateStore } from '../stores/communicate'
import AsyncStorage from '@react-native-async-storage/async-storage'
import Maintenance from '../screens/home/loginerror/Maintenance'
import axios from 'axios'

// redirect
const redirectUri = AuthSession.makeRedirectUri({
  native: REDIRECT_URI[Platform.OS]
})

// auth config
const configAuth = {
  clientId: CLIENT_ID,
  scopes: ['openid', 'offline_access', CLIENT_ID],
  redirectUri,
  prompt: AuthSession.Prompt.Login
}

WebBrowser.maybeCompleteAuthSession()

const Router = (): JSX.Element => {
  // TODO: will remove it later
  const auth = useAuthStore()
  const homeStore = useHomeStore()



  // request code (auth code flow)
  const [request, response, promptAsync] = AuthSession.useAuthRequest(
    configAuth,
    discovery
  )

  useEffect(() => {
    // get token - called only when you login
    if (request && response && response.type === 'success') {
      const code = response.params.code
      if (code) {
        auth.getTokenFromCode(code, request, redirectUri, {
          tokenEndpoint: discovery.tokenEndpoint
        })
      }

      const postdetails = async () => {

        await AsyncStorage.setItem('login', JSON.stringify(true))
      }
      postdetails()


    }

    return () => { }
  }, [response, request])


  useEffect(() => {
    // get token from storage
    auth.getPersistedAuth()
  }, [auth.requireRefresh])

  const navTheme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      background: colorPalette.lighter
    }
  }



  useEffect(() => {
    homeStore.fetchMaintenance()
  }, [])



  return (
    <NavigationContainer theme={navTheme}>

      {homeStore.maintenanceData?.isMaintainance ? (
        <Maintenance message={homeStore?.maintenanceData?.message} />
      ) : auth.token ? (
        <AppStack />
      ) : request && (
        <AuthStack
          request={request}
          action={() => promptAsync({ useProxy: false, showInRecents: true })}
        />
      )}
      {/* 
      {auth.token ? (
        <AppStack />
      ) : (
        request && (
          <AuthStack
            request={request}
            action={() => promptAsync({ useProxy: false, showInRecents: true })}
          />
        )
      )} */}
    </NavigationContainer>
  )
}

export default Router
